import React from "react";
import Chart from "../../Chart";
import ExampleRadarChart from "../../../../components/Chart/ExampleRadarChart";

class RadarChartExampleApplet extends Chart {

    render() {
        return <ExampleRadarChart applet={this}
                          attributes={this.state.Attributes}
                          radar={this.state.radar}
                          series={this.state.Series}
                          sx={this.state.sx}
                          enterpriseComponent={this.getEnterpriseComponent()} />;
    }

    state = {
        Name: "RadarChartExampleApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        Attributes: {
            Height: 300,
            Margin: {right: 24},
        },
        radar: {
            metrics: [],
        },
        Series: [
            {
                type: "radar",
                data: [],
                id: "pvId",
                label: "pv",
            },
            {
                type: "radar",
                id: "uvId",
                data: [],
                label: 'uv'
            }
        ]
    }
}

export default RadarChartExampleApplet;
